<li class="nav-item" (click)="redirectToPOS()">
  <a>
    POS
  </a>
</li>